// Tipos compartidos del wizard de Rendición de Campaña
import type {
  EstadoRendicion,
  ModalidadAporte,
  TipoPersonaAportante,
  TipoPresentacionRendicion,
} from '../../../services/api';

export type TipoEleccion =
  | 'LEGISLATIVA_PROVINCIAL'
  | 'EJECUTIVA_PROVINCIAL'
  | 'MUNICIPAL'
  | 'CONSEJO_MAGISTRATURA';

export type EtapaEleccion = 'PRIMARIA' | 'GENERAL' | 'SEGUNDA_VUELTA';

export type TipoMovimientoCampana = 'INGRESO' | 'EGRESO';

export interface CandidaturaCampana {
  id: string;
  rendicionCampanaId: string;
  categoria: string;
  detalle: string | null;
  orden: number;
  creadoEn: string;
  actualizadoEn: string;
}

export interface RendicionCampana {
  id: string;
  partidoId: string;
  expedienteId: string | null;
  tipoPresentacion: TipoPresentacionRendicion;
  tipoEleccion: TipoEleccion;
  etapa: EtapaEleccion;
  fechaActoElectoral: string;
  estado: EstadoRendicion;
  versionActual: number;
  hashActual: string | null;
  fechaPresentacion: string | null;
  fechaVencimiento: string | null;
  fechaAprobacion: string | null;
  pdfFirmadoUrl: string | null;
  codigoSpeca: string | null;
  versionSpeca: number | null;
  creadoEn: string;
  actualizadoEn: string;
  partido?: {
    id: string;
    numero: number;
    denominacion: string;
    sigla: string | null;
    tipo: string;
    domicilioLegal: string | null;
    localidad: string | null;
    codigoPostal: string | null;
  };
  candidaturas?: CandidaturaCampana[];
}

export interface AporteCampana {
  id: string;
  rendicionCampanaId: string;
  apellido: string;
  nombre: string | null;
  razonSocial: string | null;
  dni: string | null;
  cuit: string;
  tipoPersona: TipoPersonaAportante;
  modalidad: ModalidadAporte;
  descripcionEspecie: string | null;
  fecha: string;
  importe: number | string;
  alertaProveedorEstado: boolean;
  creadoEn: string;
}

export interface AportesCampanaTotales {
  humanasDinero: number;
  humanasEspecie: number;
  juridicasDinero: number;
  juridicasEspecie: number;
  total: number;
  cantidadAlertas: number;
}

export interface PlanCuentaCampana {
  codigo: string;
  denominacion: string;
  nivel: number;
  rubroPadre: string | null;
  tipo: TipoMovimientoCampana | null;
  esAutoCalculada: boolean;
}

export interface MovimientoCampana {
  id: string;
  rendicionCampanaId: string;
  codigoCuenta: string;
  denominacion: string;
  tipo: TipoMovimientoCampana;
  importe: number | string;
  esAutoCalculado: boolean;
  readonly: boolean;
  planCuenta?: PlanCuentaCampana;
}

export interface ResumenCampana {
  totalIngresos: number;
  totalEgresos: number;
  resultado: number;
  cuentasIngresoConMovimiento: number;
  cuentasEgresoConMovimiento: number;
}

export interface RendicionCampanaListItem {
  id: string;
  expedienteId: string | null;
  tipoPresentacion: TipoPresentacionRendicion;
  tipoEleccion: TipoEleccion;
  etapa: EtapaEleccion;
  fechaActoElectoral: string;
  fechaVencimiento: string | null;
  fechaPresentacion: string | null;
  estado: EstadoRendicion;
  versionActual: number;
  creadoEn: string;
  actualizadoEn: string;
}

export const LABEL_TIPO_ELECCION: Record<TipoEleccion, string> = {
  LEGISLATIVA_PROVINCIAL: 'Elecciones Legislativas Provinciales',
  EJECUTIVA_PROVINCIAL: 'Elecciones Ejecutivas Provinciales',
  MUNICIPAL: 'Elecciones Municipales',
  CONSEJO_MAGISTRATURA: 'Consejo de la Magistratura',
};

export const LABEL_ETAPA: Record<EtapaEleccion, string> = {
  PRIMARIA: 'Primarias (PASO)',
  GENERAL: 'Generales',
  SEGUNDA_VUELTA: 'Segunda Vuelta',
};
